import type { IBanners } from "@/types/global"
import { ref } from "vue"

const logo = ref(null)
const banners = ref<IBanners[]>([])
const promoBanner = ref(null)

export function useLogoBanner() {
  function setBanners(nav) {
    banners.value = nav
  }

  function setPromoBanner(nav) {
    promoBanner.value = nav
  }

  function setLogo(nav) {
    logo.value = nav
  }

  return {
    setBanners,
    setLogo,
    setPromoBanner,
    logo,
    banners,
    promoBanner,
  }
}
